import React from 'react';

export default function OficioReniecyt() {
  return (
    <div className="container mx-auto py-16 px-4">
      <h1 className="text-2xl font-semibold mb-6 text-center">Oficio Reniecyt</h1>
      <div className="max-w-3xl mx-auto">
        <img
          src="https://recursos.cenid.org/img_cenid/constancia_definitivo.png"
          alt="Oficio Reniecyt"
          className="w-full h-auto object-contain shadow-md rounded"
        />
      </div>
    </div>
  );
}
